import React, { useState, memo } from 'react';
import ContextMenu from 'ContextMenu';
import '@styles/editField/TimeFrameCard.css';
import editIcon from 'images/icons/edit_field/edit_icon.svg';
import trashIcon from 'images/icons/trash.svg';
import threeDotsIcon from 'images/icons/three-dots-horizontal.svg';
const chevronDownIcon = require('images/icons/open_arrow_grey71.svg');
const chevronRightIcon = require('images/icons/close_arrow_grey71.svg');
const moment = require('moment');
import { useTranslation } from 'react-i18next';
import { upper } from '@managers/helpers';

const MENU_OPTIONS = (onEdit, onDelete) => [
  {
    title: 'Edit',
    icon: editIcon,
    func: onEdit,
  },
  {
    title: 'Delete',
    icon: trashIcon,
    func: onDelete,
    textColor: '#F66B7A',
  },
];

const InfoGroup = ({ title, subTitle, content }) => (
  <div className='info-group'>
    <div className='info-title'>
      {upper(title)} {subTitle}
    </div>
    <div className='info-content'>{content}</div>
  </div>
);

const SourceTag = ({ source }) => (
  <div className='source-group'>
    <div className='info-title'>{upper('source')}:</div>
    <div className='source-tag'>{source}</div>
  </div>
);

const TimeFrameItem = memo(
  ({ tf, minData, maxData, userLengthUnits, onEdit, onDelete, typeConfig }) => {
    const { t } = useTranslation();
    const [showMenu, setShowMenu] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const menuOptions = MENU_OPTIONS(onEdit, onDelete);

    const formatDate = (date = '') => {
      return date ? moment(date).format('D MMM YYYY') : '';
    };

    const frequencyLabel = typeConfig?.label;
    const frequencyDisplayValue =
      typeConfig?.frequencyOptions?.find(
        (opt) => opt.value == tf[typeConfig?.key],
      )?.title ||
      tf[typeConfig?.key] ||
      '';

    return (
      <div className='timeframe-item'>
        <div className='timeframe-item-content'>
          <div
            onClick={() => {
              setIsExpanded(!isExpanded);
            }}
            className='timeFrameOpenBtn d-flex justify-content-center align-items-center'
            style={{ width: '24px', height: '24px', marginTop: '20px' }}
          >
            <img src={isExpanded ? chevronDownIcon : chevronRightIcon} />
          </div>

          <div className='timeframe-main-info'>
            <div className='timeframe-row'>
              <InfoGroup
                title={frequencyLabel}
                content={upper(frequencyDisplayValue)}
              />
              <div className='info-group-wrapper two-sides-vertical-divider'>
                <div className='timeframe-first-row'>
                  <InfoGroup
                    title={t('start_date')}
                    content={formatDate(tf.active_period_start_date)}
                  />
                  <InfoGroup
                    title={t('end_date')}
                    content={
                      formatDate(tf.active_period_end_date) ||
                      t('Timeframe_end_of_season')
                    }
                  />
                </div>
                {isExpanded ? (
                  typeConfig?.showHours ? (
                    <div className='timeframe-second-row'>
                      <div className='timeframe-hours'>
                        <InfoGroup
                          title={t('start_hour')}
                          content={tf.start_hour}
                        />
                        <InfoGroup
                          title={t('end_hour')}
                          content={tf.end_hour}
                        />
                      </div>
                    </div>
                  ) : (
                    <div style={{ height: 40 }} />
                  )
                ) : null}
              </div>
              <div className='info-group-wrapper'>
                <div className='timeframe-first-row'>
                  <InfoGroup
                    title={`${t('min')}`}
                    subTitle={`(${userLengthUnits})`}
                    content={tf.min || minData.placeholder}
                  />
                  <InfoGroup
                    title={`${t('max')}`}
                    subTitle={`(${userLengthUnits})`}
                    content={tf.max || maxData.placeholder}
                  />
                </div>
                {isExpanded && (
                  <div className='timeframe-second-row'>
                    <div className='timeframe-sources'>
                      <SourceTag source={minData.source} />
                      <SourceTag source={maxData.source} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='menu-container'>
          <button
            className={`menu-button ${showMenu ? 'active' : ''}`}
            onClick={(e) => {
              setShowMenu(!showMenu);
              e.stopPropagation();
            }}
            type='button'
          >
            <img src={threeDotsIcon} alt='menu' />
          </button>
          {showMenu && (
            <ContextMenu options={menuOptions} onToggle={setShowMenu} />
          )}
        </div>
      </div>
    );
  },
);

export default TimeFrameItem;
